import React from 'react';

const SvgBg = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BG_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BG_svg__b" fill="#fff">
        <use xlinkHref="#BG_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#06A77C" mask="url(#BG_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path fill="#E32E19" mask="url(#BG_svg__b)" d="M0 13.333h28V20H0z" />
    </g>
  </svg>
);

export default SvgBg;
